import { render, staticRenderFns } from "./UserEditDialog.vue?vue&type=template&id=5a8dca9d&scoped=true"
import script from "./UserEditDialog.vue?vue&type=script&lang=js"
export * from "./UserEditDialog.vue?vue&type=script&lang=js"
import style0 from "./UserEditDialog.vue?vue&type=style&index=0&id=5a8dca9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8dca9d",
  null
  
)

export default component.exports